import {
  getData,
  postData
} from './Services'

export const getEmpresa = async () => {
  try {
    const res = await getData('/empresas/1');
    return res;
  } catch (error) {
    console.error("Error al obtener los datos de la empresa:", error);
    return null; // O un objeto vacío {} si prefieres devolver algo manejable
  }
};


export const postContacto = async ({ nombre, email, asunto, mensaje, destinatario }) => {
  try {
    const res = await postData('/empresas/contacto', { nombre, email, asunto, mensaje, destinatario });
    return res;
  } catch (error) {
    console.error("Error al enviar el formulario de contacto:", error);
    throw error;
  }
};

